import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";

const FormikCheckGroup = ({
  label,
  field,
  form: { touched, errors, setFieldValue },
  name,
  options,
  row,
  helpText,
  ...props
}) => {
  const fieldName = name || field.name;

  useEffect(() => {
    return () => {
      setFieldValue(field.name, null);
    }
  }, []);

  const handleChange = (el) => (e) => {
    let value = field.value ? (Array.isArray(field.value) ? field.value : [field.value]) : [];
    if (!e.target.checked) {
      value = value.filter((v) => v !== el.value);
    } else {
      value.push(el.value);
    }
    setFieldValue(field.name, value);
  };

  return (
    <FormControl error={errors[fieldName]}>
      {label && <FormLabel>{label}</FormLabel>}
      <FormGroup row={row}>
        {options.map((i) => (
          <FormControlLabel
            key={i.value}
            control={
              <Checkbox
                checked={field.value?.includes(i.value)}
                onChange={handleChange(i)}
                value={i.value}
              />
            }
            label={i.label}
          />
        ))}
      </FormGroup>
      { helpText && <FormHelperText>{helpText}</FormHelperText>}
      {touched[fieldName] && errors[fieldName] && (
        <FormHelperText>{errors[fieldName]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default FormikCheckGroup;
